<template>
  <v-btn
    v-if="isAdmin && totalTestators > 0"
    :loading="csvDownloading"
    depressed
    @click="csvDownloading = true"
  >
    <v-icon small>{{ icons.mdiDownload }}</v-icon>
    Download csv
  </v-btn>
</template>

<script>
  import { ALL_TESTATORS_QUERY } from '../../constants/graphql/testators';
  import { csvExport } from '../../constants/js/csv';
  import moment from 'moment';
  import { verificationStatus } from '../../constants/js/will-verification';

  export default {
    name: 'DownloadTestatorListCsv',
    props: {
      totalTestators: {
        type: Number,
        required: true,
      },
      company: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        allTestators: {},
        csvDownloading: false,
      };
    },
    computed: {
      csvData() {
        return this.allTestators.map(testator => {
          var details = {
            'ID Number': testator.idNumber,
            'Full name': testator.firstNames
              ? `${testator.firstNames} ${testator.lastName}`
              : '',
            Email: testator.email,
            'Invite date': this.$options.filters.date_DMMMYYYY(
              testator.createdAt
            ),
            'Last login date': this.$options.filters.date_DMMMYYYY(
              testator.lastLogin
            ),
            'Payment plan': this.formatPaymentPlan(testator.paymentPlan),
            'Next billing date': this.$options.filters.date_DMMMYYYY(
              testator.nextBillingDate
            ),
            Advisor: testator.advisorEmail,
            'Estate Costs': testator.estimatedEstateAdministrativeCosts,
            'Total steps completed': testator.numberOfCompletedSteps,
            'Last will download date': this.$options.filters.date_DMMMYYYY(
              testator.lastWillDownloadDate
            ),
            'Will check': this.verificationStatusDetails(testator.uploadStatus)
              .status,
            Status: testator.status,
            'Unique Identifier': testator.uniqueIdentifier,
          };
          if (this.company.insuranceStep == 'NO_INSURANCE') {
            delete details['Estate Costs'];
          }
          if (this.company.willPaymentOption == 'ALWAYS_FREE') {
            delete details['Payment plan'];
            delete details['Next billing date'];
          }

          return details;
        });
      },
      csvFileName() {
        return `Testators list as of ${moment().format('D MMM YYYY')}.csv`;
      },
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
    },
    methods: {
      verificationStatusDetails(status) {
        return verificationStatus(status, this.icons);
      },
      formatPaymentPlan(paymentPlan) {
        switch (paymentPlan) {
          case 'subscription':
            return 'Subscription';
          case 'once_off':
            return 'Once off';
          case 'free_company_will':
            return 'Free company will';
          default:
            return '';
        }
      },
    },
    apollo: {
      allTestators: {
        query: ALL_TESTATORS_QUERY,
        skip() {
          return !this.csvDownloading;
        },
        fetchPolicy: 'cache-and-network',
        result(response) {
          if (response.data) {
            csvExport(this.csvData, this.csvFileName);
            this.csvDownloading = false;
          }
        },
        update: data => data.allTestators.testators,
      },
    },
  };
</script>
